// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__14IRR","requiredAsterisk":"Info_requiredAsterisk__I6Id5"};